import { Box, Button } from "@mui/material";
import { AccessTimeOutlined } from "@mui/icons-material";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { WidgetComponentMaps } from "../../../common/WidgetComponentMaps";
import { filledButton } from "../../../ui/styles/buttonStyles";
import TimeSheet from "../../TimeSheet";

export const TimeSheetWidget = ({ swapyName = "timeSheetWidget", sx }) => {
  return (
    <WidgetComponentMaps
      swapyName={swapyName}
      title="Organization Time Sheets"
      description="Review and manage recorded work hours, tracked time, and related timesheet activity for your organization."
      icon={<AccessTimeOutlined />}
      sxProp={{
        ...sx,
        height: { xs: "400px", md: "450px", lg: "100%" },
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ flex: 1 }} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          bgcolor: "transparent",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <BaseModalComponent
            modalKey="Organization-TimeSheets"
            modalLabel="Manage Time Sheets"
            elementTrigger={<Button sx={filledButton}>Manage time sheets</Button>}
          >
            <TimeSheet />
          </BaseModalComponent>
        </Box>
      </Box>
    </WidgetComponentMaps>
  );
};
